import {
	TableHead,
	TableHeader,
	TableRow,
} from '@cocoonspace/ui/components/table'
import { Trans } from '@lingui/react/macro'

export const InvoicesTableHeader = () => (
	<TableHeader>
		<TableRow className='divide-border/75 divide-x divide-dashed'>
			<TableHead className='w-[100px]'>
				<Trans>Date</Trans>
			</TableHead>

			<TableHead>
				<Trans>Ref facture</Trans>
			</TableHead>

			<TableHead>
				<Trans>Ref réservation</Trans>
			</TableHead>

			<TableHead className='w-[150px]'>
				<Trans>Statut</Trans>
			</TableHead>

			<TableHead className='w-[150px]'>
				<Trans>Montant HT</Trans>
			</TableHead>

			<TableHead className='w-[150px]'>
				<Trans>Montant TTC</Trans>
			</TableHead>

			<TableHead className='w-[50px]' />
		</TableRow>
	</TableHeader>
)
